import { ShieldCheck, Lock, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 mt-24 bg-[#0a0a0a]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
      <div className="space-y-4">
        <Logo />
        <p className="text-sm text-zinc-500 max-w-sm leading-relaxed">
          JACKPOT AZ rəsmi lisenziyalı onlayn kazino platformasıdır. Məsuliyyətlə oynayın.
        </p>
        <span className="inline-flex items-center justify-center w-11 h-11 rounded-full border-2 border-[#c4112f] font-display font-bold text-sm text-[#c4112f]">18+</span>
      </div>
      <div className="space-y-3 text-sm text-zinc-400">
        <p className="uppercase tracking-[0.2em] text-xs text-zinc-600">Təhlükəsizlik</p>
        <p className="flex items-center gap-2"><ShieldCheck size={16} className="text-[#D4AF37]" /> Rəsmi lisenziya</p>
        <p className="flex items-center gap-2"><Lock size={16} className="text-[#D4AF37]" /> SSL şifrələmə</p>
        <p className="flex items-center gap-2"><Clock size={16} className="text-[#D4AF37]" /> 24/7 dəstək</p>
      </div>
      <div className="space-y-3 text-sm text-zinc-400">
        <p className="uppercase tracking-[0.2em] text-xs text-zinc-600">Ödənişlər</p>
        <p>Bank kartı · Visa / Mastercard</p>
        <p>m10 elektron pul kisəsi</p>
        <p>Min. depozit 15 ₼ · Min. çıxarış 25 ₼</p>
        <p>Maks. çıxarış 5 000 ₼ · gündə 10 dəfə</p>
      </div>
    </div>
    <div className="text-center text-xs text-zinc-600 pb-8">© {new Date().getFullYear()} JACKPOT AZ. Bütün hüquqlar qorunur.</div>
  </footer>
);
